import {Header} from "./header";

const MainPage = () => {

    return (
        <div>
            <Header/>
            <div className={"mt-6 text-white p-2"}>
                <h1>Some useful (not) information about project, but you only click on button above.</h1>
            </div>
        </div>
    )
}

export default MainPage